import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http'
import {MatSnackBarModule} from '@angular/material/snack-bar'


@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        MatSnackBarModule],
    providers: [
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class HttpModule {
}
